import { useMutation, useQueryClient } from "react-query";
import axios, { AxiosError, AxiosResponse } from "axios";
import { toast } from "react-toastify";
import OpeningTime from "../../OpeningTimes/OpeningTime";
import { openingTimesUrls } from "../../URL/ApplicationUrls";
import { OpeningTimeMapper } from "../../OpeningTimes/OpeningTimeMapper";
import { openingTimeWithIdQueryKey } from "../../OpeningTimes/openingTimeQueryKeys";
import { addSuccessMessage } from "../../Messages/successMessages";
import { MdmApiError } from "../../Errors/MdmApiError";
import { apiErrorNotificationToast } from "../../Errors/apiErrorNotificationToast";

export const useAddPlantOpeningTime = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (openingTime: OpeningTime) =>
      axios.post<number>(
        openingTimesUrls.openingTimesForPlantsWithId(openingTime.ParentId),
        OpeningTimeMapper.toWriteDto(openingTime, 0)
      ),
    onSuccess: async (response: AxiosResponse<number>, variables: OpeningTime) => {
      await queryClient.invalidateQueries(openingTimeWithIdQueryKey(variables.ParentId, "plants"));
      toast.success(addSuccessMessage(response.data, "OpeningTime"));
    },
    onError: (error: AxiosError<MdmApiError>) => {
      apiErrorNotificationToast(error);
    },
  });
};
